module.exports = __webpack_public_path__ + "img/53.610e87ce.jpg";